<template>
    <div class="tablePage">
        <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headCellStyle" :height="tableHeight" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :label="$t('public.table_carrier_name')" prop="carrierName" show-overflow-tooltip
                width="150px">
                <template #default="{ row }">
                    <i v-icon:theme="['carrierTypeConvert', row.carrierType]"></i>
                    <i v-icon:theme="['operationResultConvert', row.status]"></i>

                    <span>{{ row['carrierName'] }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="carrierScopeName" width="150" show-overflow-tooltip :label="$t('labelTitle.Range')"
                v-if="isSysAdmin"></el-table-column>

            <el-table-column prop="structureName" :label="$t('public.table_arch')" show-overflow-tooltip></el-table-column>
            <el-table-column prop="event" :label="$t('public.event')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ $t(eventFn(row.event)) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="behavior" :label="$t('public.op_type')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ behaviorFn(row.event, row.behavior, row.behaviorParam) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="recordTime" :label="$t('public.op_time')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ $timetransition(row['recordTime']) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="operator" :label="$t('integration.operator')" show-overflow-tooltip> </el-table-column>
            <el-table-column :label="$t('tableTitle.Operation')" width="100" align="center" fixed="right">
                <template #default="{ row }">
                    <el-button v-for="item in tableBtn" :key="item.id" @click="handle(row, item.method)" type="text"
                        size="small" :title="$t(item.title)" :icon="item.icon"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: ['loading', 'tableData'],
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return currentUser.sysScope && currentUser.sysAdmin;
        }
    },

    data() {
        return {
            tableHeight: '100%',
            total: 0,
            flag: false,
            title: '',
            isShow: false,
            editForm: {
                id: null,
                status: null
            },
            statusArray: [],
            tableBtn: [
                {
                    id: 1,
                    title: 'buttonTitle.Details',
                    icon: 'el-icon-tickets',
                    method: 'detailFn',
                    vHas: [''],
                    isBtn: true
                },
                {
                    id: 2,
                    title: 'buttonTitle.Delete',
                    icon: 'el-icon-delete',
                    method: 'rowDel',
                    vHas: ['incubatorDelCarrier'],
                    isBtn: true
                }
            ],
            stautsIconArray: ['iconfont icon-yunhang', 'iconfont icon-beiyong', 'iconfont icon-baofei', 'iconfont icon-daixiugai', 'iconfont icon-chushuang'],
            getCarrierStatus: [],
            eventArray: [
                {
                    id: 1,
                    label: $t('business.carrier_equipment'),
                    children: [
                        {
                            id: 1,
                            // label: '取消-设备关联'
                            label: $t('public.btn_new')+$t('integration.installation_point')+'-'+$t('integration.associated_device')
                        },
                        {
                            id: 2,
                            // label: '监测点-关联'
                            label:  $t('public.edit')+$t('integration.installation_point')+'-'+$t('integration.associated_device')
                        },
                        {
                            id: 3,
                            // label: '设置-辅助'
                            label:  $t('public.btn_delete')+$t('integration.installation_point')+'-'+$t('integration.disassociated_device')
                        }
                    ]
                },
                {
                    id: 2,
                    label: $t('integration.abnormal_record'),
                    children: [
                        {
                            id: 1,
                            label: $t('public.handle')+'-'+$t('integration.exception_occurred')
                        },
                        {
                            id: 2,
                            label: $t('public.tbopt_delete')+'-'+$t('integration.exception_occurred')
                        }
                    ]
                },
                {
                    id: 3,
                    label: 'business.record_point',
                    children: [
                        {
                            id: 1,
                            label: $t('public.setting')+'-'+$t('integration.record_point')
                        },
                        {
                            id: 2,
                            label: $t('public.close')+'-'+$t('integration.record_point')
                        }
                    ]
                },
                {
                    id: 4,
                    label: $t('integration.mount_information'),
                    children: [
                        {
                            id: 1,
                            label: $t('integration.newly_added')
                        },
                        {
                            id: 2,
                            label: $t('integration.to_update')
                        },
                        {
                            id: 3,
                            label: $t('public.tbopt_delete')
                        }
                    ]
                },
                {
                    id: 5,
                    label: $t('integration.alarm_settings'),
                    children: [
                        {
                            id: 1,
                            label: $t('public.start')+'-'+$t('integration.alarm_settings')
                        },
                        {
                            id: 2,
                            label: $t('public.revoke')+'-'+$t('integration.alarm_settings')
                        }
                    ]
                }
            ]
        };
    },
    mounted() {
        this.getCarrierStatus = JSON.parse(sessionStorage.getItem('getCarrierStatus'));
    },
    methods: {
        eventFn(eventId) {
            let str = '';
            for (const item of this.eventArray) {
                if (item.id === eventId) {
                    str = item.label;
                    break;
                }
            }
            return str;
        },
        behaviorFn(eventId, behaviorId, behaviorParam) {
            let str = '';
            let JsonContent = '';
            if (behaviorParam) {
                JsonContent = JSON.parse(behaviorParam);
            }
            this.eventArray.forEach(item => {
                if (item.id === eventId) {
                    item.children.forEach(opt => {
                        if (opt.id === behaviorId) {
                            const array = opt.label.split('-');
                            str = this.behavierTemplate(eventId, array, JsonContent, behaviorId);
                        }
                    });
                }
            });

            return str;
        },
        behavierTemplate(eventId, array, row, behaviorId) {
            console.log(row);
            let str = '';
            switch (eventId) {
                // 设备一对多
                case 1: {
                    // const newArray = row.map(item => {
                    //     return `[${item.name}(` + this.$t(`deviceType.${item.code}`) + ')]';
                    // });
                    // str = `${array[0]}` + newArray.join(',') + array[1];
                    str = `${array[0]}[${row.name}]${array[1]}[${row.device}]`;
                    break;
                }
                case 2: {
                    const newArray = row.map(item => {
                        return this.$timetransition(item.timestamp);
                    });
                    str = `${array[0]}` + newArray.join(',') + array[1];
                    break;
                }
                case 3: {
                    str = behaviorId === 1 ? $t('integration.set_recording_point') : $t('integration.close_record_point');
                    break;
                }
                case 4: {
                    str = `${array[0]}` + `[${row.name}-` + this.$t(`carrier.${row.typeId}`) + ']' + (array[1] ? array[1] : '');
                    break;
                }
                case 5: {
                    str = `${array[0]}[${row.map(item => item.name).join(',')}]${array[1]}`;
                    break;
                }
                default:
                    break;
            }

            return str;
        },
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg);
        },
        handle(row, Fn) {
            this.$emit(Fn, row);
        }
    }
};
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);

    i {
        color: #ccc;
    }
}
</style>
